/* footer-section.tsx generated by @compiled/babel-plugin v0.38.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./footer-section.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Fragment, lazy, Suspense, useState } from 'react';
import { useIntl } from 'react-intl-next';
import { cx } from '@atlaskit/css';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { FlagGroup } from '@atlaskit/flag';
import RovoIcon from '@atlaskit/icon-lab/core/rovo';
import InfoIcon from '@atlaskit/icon/core/migration/status-information--info';
import PenIcon from '@atlaskit/icon/core/pen';
import { RovoIcon as RovoIconLegacy } from '@atlaskit/legacy-custom-icons';
import Link from '@atlaskit/link';
import { RovoIcon as RovoIconLogo } from '@atlaskit/logo';
import Lozenge from '@atlaskit/lozenge';
import { ModalTransition } from '@atlaskit/modal-dialog';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Flex, Text } from '@atlaskit/primitives/compiled';
import ProfileClient from '@atlaskit/profilecard/client';
import ProfileCardTrigger from '@atlaskit/profilecard/user';
import { N40A, N700, N900 } from '@atlaskit/theme/colors';
import { getFrontendExperiment } from '@atlassian/search-experiment';
import { useAIAnswerContext } from '../../../ai-answer-dialog/ai-answer-context';
import { AiBrand } from '../../../constants';
import { onCuratedDefinitionSeeEditHistoryButtonClicked } from '../analytics';
import { ATLASSIAN_INTELLIGENCE_TRUST_LINK, ATLASSIAN_ROVO_LINK } from '../common/constants';
import { AtlassianIntelligenceIcon } from '../common/icons/atlassian-intelligence-icon';
import { DefinitionUpdateConfirmationFlag } from '../curated/edit-definition-modal/definition-update-confirmation-flag';
import { EditDefinitionModal } from '../curated/edit-definition-modal/edit-definition-modal';
import { FeedbackButtons } from './feedback-buttons';
import { FeedbackModal } from './feedback-modal';
import { FeedbackOptionsModal } from './feedback-options-modal';
import { messages } from './messages';
var styles = {
  aiFooter: "_1e0c1txw _4cvr1h6o _1bah1yb4 _ca0q1b66 _n3td1b66 _19bvv47k _u5f3v47k _uwhke4h9 _15a5nqa1 _1i53xs3e _1bsb1osq",
  aiFooterUpdates: "_19bvpxbi _u5f3pxbi",
  rovoWrapper: "_ca0q1b66 _n3td1b66",
  contentMayVaryWrapper: "_zulp1b66 _11c81o8v _1e0c1txw _4cvr1h6o _syaz1rpy",
  brandWrapper: "_11c81o8v _1e0c1txw _4cvr1h6o _syaz1rpy",
  editedByFooter: "_1e0c1txw _4cvr1h6o _1bah1yb4 _ca0qutpp _n3tdutpp _19bvv47k _u5f3v47k _uwhke4h9 _15a5nqa1 _1i53xs3e",
  editedByWrapper: "_2rko1rr0 _1e0c1txw _bfhk1n5j _19bv1b66 _u5f31b66 _18u01b66 _80omtlke _irr3ux6y",
  definedByWrapper: "_18u0u2gc",
  activeEditedByWrapper: "_2rko1rr0 _1e0c1txw _bfhkux6y _19bv1b66 _u5f31b66 _18u01b66 _80omtlke",
  editHistoryWrapper: "_11c81o8v _1e0c1txw _syaz13af _19bv1ejb _80omtlke _bfhksm61 _9oik1r31 _1bnx8stv _jf4cnqa1"
};
var AkFeedbackFlag = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/product-search-dialog/feedback-flag" */'@atlaskit/feedback-collector').then(function (_ref) {
    var FeedbackFlag = _ref.FeedbackFlag;
    return {
      default: FeedbackFlag
    };
  });
});
export var AIDefinitionFooterSection = function AIDefinitionFooterSection() {
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage,
    locale = _useIntl.locale;
  var _useAIAnswerContext = useAIAnswerContext(),
    answerEditor = _useAIAnswerContext.answerEditor,
    brand = _useAIAnswerContext.brand,
    readingAidsOptions = _useAIAnswerContext.readingAidsOptions;
  var _ref2 = readingAidsOptions || {},
    definitionCurationOptions = _ref2.definitionCurationOptions;
  var editDefinitionEnabled = !!definitionCurationOptions;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showFeedbackOptionsModal = _useState2[0],
    setShowFeedbackOptionsModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showEditDefinitionModal = _useState4[0],
    setShowEditDefinitionModal = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showFeedbackModal = _useState6[0],
    setShowFeedbackModal = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    displayFlag = _useState8[0],
    setDisplayFlag = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    displaySuccessFlag = _useState0[0],
    setDisplaySuccessFlag = _useState0[1];
  var _getFrontendExperimen = getFrontendExperiment({
      abTestId: 'kd_definitions_ux_uplift_exp'
    }),
    serveDefinitionsUXExp = _getFrontendExperimen.serveExperiment;
  var serveDefinitionUXUpdates = serveDefinitionsUXExp && fg('kd_definitions_ux_uplift_exp_gate');
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.aiFooter, serveDefinitionUXUpdates && styles.aiFooterUpdates)
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.contentMayVaryWrapper
  }, brand === AiBrand.ROVO ? null : /*#__PURE__*/React.createElement(Lozenge, null, formatMessage(messages.definition_footer_beta_status_label)), /*#__PURE__*/React.createElement(InfoIcon, {
    label: "",
    color: "var(--ds-icon-subtle, #626F86)",
    LEGACY_size: "small",
    size: "small"
  }), /*#__PURE__*/React.createElement(Link, {
    rel: "noopener noreferrer",
    appearance: "subtle",
    href: ATLASSIAN_INTELLIGENCE_TRUST_LINK
  }, formatMessage(messages.definition_footer_disclaimer))), !serveDefinitionUXUpdates && /*#__PURE__*/React.createElement(Box, {
    xcss: styles.brandWrapper
  }, brand === AiBrand.ROVO ? /*#__PURE__*/React.createElement(Flex, null, FeatureGates.getExperimentValue('rovo_awareness_experiment', 'cohort', 'not-enrolled') === 'test' ? /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    gap: "space.050",
    xcss: styles.rovoWrapper
  }, /*#__PURE__*/React.createElement(RovoIconLogo, {
    size: "xxsmall",
    appearance: "brand",
    shouldUseNewLogoDesign: true,
    testId: "rovo-icon"
  }), /*#__PURE__*/React.createElement(Link, {
    rel: "noopener noreferrer",
    appearance: "subtle",
    href: ATLASSIAN_ROVO_LINK
  }, "Rovo")) : /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    gap: "space.025"
  }, /*#__PURE__*/React.createElement(Link, {
    rel: "noopener noreferrer",
    appearance: "subtle",
    href: ATLASSIAN_ROVO_LINK
  }, "Rovo"), /*#__PURE__*/React.createElement(RovoIcon, {
    label: "",
    color: "var(--ds-icon-subtle, #505258)",
    LEGACY_fallbackIcon: RovoIconLegacy,
    spacing: "spacious"
  }))) : /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    gap: "space.025"
  }, formatMessage(messages.definition_footer_powered_by_AI), /*#__PURE__*/React.createElement(AtlassianIntelligenceIcon, {
    greyed: true,
    size: "large"
  }))), serveDefinitionUXUpdates && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(FeedbackButtons, {
    setShowFeedbackOptionsModal: setShowFeedbackOptionsModal,
    setDisplayFlag: setDisplayFlag
  }))), /*#__PURE__*/React.createElement(ModalTransition, null, showFeedbackOptionsModal && /*#__PURE__*/React.createElement(FeedbackOptionsModal, {
    setShowFeedbackOptionsModal: setShowFeedbackOptionsModal,
    setShowEditDefinitionModal: setShowEditDefinitionModal,
    setShowFeedbackModal: setShowFeedbackModal,
    editDefinitionEnabled: editDefinitionEnabled
  }), showFeedbackModal && /*#__PURE__*/React.createElement(FeedbackModal, {
    setFeedbackModal: setShowFeedbackModal,
    isCuratedDefinition: !!answerEditor,
    setDisplayFlag: setDisplayFlag
  }), showEditDefinitionModal && editDefinitionEnabled && /*#__PURE__*/React.createElement(EditDefinitionModal, {
    curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
    closeEditModal: function closeEditModal() {
      return setShowEditDefinitionModal(false);
    },
    openFeedbackOptionsModal: function openFeedbackOptionsModal() {
      return setShowFeedbackOptionsModal(true);
    },
    onSaveEditModal: function onSaveEditModal() {
      return setDisplaySuccessFlag(true);
    }
  })), displayFlag && /*#__PURE__*/React.createElement(FlagGroup, {
    onDismissed: function onDismissed() {
      return setDisplayFlag(false);
    }
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Fragment, null)
  }, /*#__PURE__*/React.createElement(AkFeedbackFlag, {
    locale: locale,
    description: formatMessage(messages.definition_footer_feedback_flag_description)
  }))), displaySuccessFlag && /*#__PURE__*/React.createElement(DefinitionUpdateConfirmationFlag, {
    onDismissed: function onDismissed() {
      return setDisplaySuccessFlag(false);
    }
  }));
};
var DEFAULT_GRAPHQL_DIRECTORY_ENDPOINT = '/gateway/api/directory/graphql';
var profileClient = new ProfileClient({
  url: DEFAULT_GRAPHQL_DIRECTORY_ENDPOINT
});
export var EditedDefinitionFooterSection = function EditedDefinitionFooterSection(_ref3) {
  var setShowEditHistoryModal = _ref3.setShowEditHistoryModal;
  var _useIntl2 = useIntl(),
    formatMessage = _useIntl2.formatMessage;
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    editorActive = _useState10[0],
    setEditorActive = _useState10[1];
  var _useAIAnswerContext2 = useAIAnswerContext(),
    answerEditor = _useAIAnswerContext2.answerEditor,
    commonAttributes = _useAIAnswerContext2.commonAttributes,
    fireAnalyticsEvent = _useAIAnswerContext2.fireAnalyticsEvent;
  var cloudId = commonAttributes.cloudId;
  if (!answerEditor) {
    return null; // This line should not be reachable since the component is only rendered when answerEditor is defined
  }
  var _getFrontendExperimen2 = getFrontendExperiment({
      abTestId: 'kd_definitions_ux_uplift_exp'
    }),
    serveDefinitionsUXExp = _getFrontendExperimen2.serveExperiment;
  var serveDefinitionUXUpdates = serveDefinitionsUXExp && fg('kd_definitions_ux_uplift_exp_gate');
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.editedByFooter
  }, /*#__PURE__*/React.createElement(Flex, {
    gap: "space.100",
    alignItems: "start",
    direction: "column"
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(PenIcon, {
    label: "",
    color: "var(--ds-icon-subtle, ".concat(N700, ")")
  }), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.definedByWrapper
  }, /*#__PURE__*/React.createElement(Text, null, formatMessage(messages.definition_footer_defined_by_text))), /*#__PURE__*/React.createElement(ProfileCardTrigger, {
    userId: answerEditor.id,
    cloudId: cloudId,
    resourceClient: profileClient,
    trigger: "click",
    onVisibilityChange: setEditorActive
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: editorActive ? styles.activeEditedByWrapper : styles.editedByWrapper
  }, "@", answerEditor.name))), !serveDefinitionUXUpdates && /*#__PURE__*/React.createElement(Box, {
    xcss: styles.editHistoryWrapper,
    onClick: function onClick() {
      fireAnalyticsEvent(onCuratedDefinitionSeeEditHistoryButtonClicked(commonAttributes));
      setShowEditHistoryModal(true);
    }
  }, formatMessage(messages.definition_footer_see_edit_history))));
};